module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/external-grey.46ddc0d9.svg";